import { render, staticRenderFns } from "./IndicatorsStatement-hk-hs.vue?vue&type=template&id=0fd40a6a"
import script from "./IndicatorsStatement-hk-hs.vue?vue&type=script&lang=js"
export * from "./IndicatorsStatement-hk-hs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports